import { useEffect, useRef } from 'react';
export function useStaggeredReveal(dependencies) {
    const rootRef = useRef(null);
    useEffect(() => {
        const root = rootRef.current;
        if (!root)
            return;
        const revealItems = root.querySelectorAll('.reveal:not(.is-visible)');
        revealItems.forEach((item, index) => {
            item.style.transitionDelay = `${Math.min(index * 70, 280)}ms`;
            item.classList.add('is-visible');
        });
    }, dependencies);
    return rootRef;
}
